import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
/*App imports*/
import { HelpersService, EstatusCreditos } from '../../../services/tools/helpers.service';
import { PagosService } from '../../../services/pagos.service';
import { CreditosService } from "../../../services/creditos.service";
import { AgregarPagoDistComponent } from './components/agregar-pago/agregar-pago-dist.component';

@Component({
  selector: 'pagos-distribucion',
  templateUrl: './pagos-distribucion.component.html',
  styleUrls: ['./pagos-distribucion.component.scss']
})
export class PagosDistribucionComponent implements OnInit {

    @Input() public idCreditos : number = null;
    @ViewChild('agregarPago') agregarPago:AgregarPagoDistComponent;

    public tablaPagos: any[] = [];
    public errors: any = {};
    public isValidShowPagos: boolean = false;
    public isValidToAddPago: boolean = false;
    public tipoCalculo: number = null;

    constructor(
      private helperService: HelpersService,
      private pagosService: PagosService,
      private creditosService: CreditosService
    ){
    }

    ngOnInit() {
    }

    public ngOnChanges(changes: SimpleChanges) {
      if (changes.idCreditos && this.idCreditos) {
        this.reloadTablaPagos();
        this.getCredito(this.idCreditos);
      }
    }

    private getCredito(idCreditos : number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.creditosService.get(idCreditos).subscribe(
          (response)=>
          {
          const credito = response.json().content;
  
          //Solo se pueden agregar pagos a los créditos vigentes
          switch(credito.statusCredito ){
            case EstatusCreditos.Vigente:
            case EstatusCreditos.Finalizado:
              this.isValidShowPagos = true;
            break;
            case EstatusCreditos.Borrador:
            case EstatusCreditos.Pendiente:
              this.isValidShowPagos = false;
          }

          this.isValidToAddPago = (credito.statusCredito === EstatusCreditos.Vigente);
          this.tipoCalculo = credito.prestamo.calculo;
          
          }, error =>
          {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          }
      );
    }

    private getTablaPagos(idCredito: number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.pagosService.getTablaPagos(idCredito).subscribe(
        (response)=>
        {
          this.tablaPagos = response.json().content;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public reloadTablaPagos(){
      this.getCredito(this.idCreditos);
      this.getTablaPagos(this.idCreditos);
    }

    public showPago(event: any, pago: any){
      this.agregarPago.showModalPago(pago.idPago);
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/components/pagos-distribucion/pagos-distribucion.component.ts